<template>
  <div>
    <name-input
      v-if="currentStage === 'name'"
      :user="users"
      @idChanged="lookupComp"
      @startCountdown="startCountdown"
    />
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :number="puzzleNumber"
      :name="`Comp-${puzzleNumber}`"
      @complete="puzzleComplete"
    />
    <pause v-if="currentStage === 'pause'" @nextPuzzle="nextPuzzle" />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="user.name"
      :time="userTime"
      :score="userScore"
    />
  </div>
</template>

<script>
import NameInput from '@/components/NameInput'
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/Puzzle'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

import firebase from 'firebase/app'
import 'firebase/firestore'

const db = firebase.firestore()

export default {
  components: {
    NameInput,
    Countdown,
    Puzzle,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'name',
      choices: [],
      times: [],
      user: { name: '', id: 0 },
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      users: {},
    }
  },

  methods: {
    lookupComp: async function(id) {
      try {
        if (this.currentStage === 'name')
          this.users = await db
            .collection('users')
            .doc(id.toString())
            .get()
            .then(result => ({ id, ...result?.data() }))
      } catch (error) {
        this.users = {}
      }
    },

    startCountdown: function(user) {
      this.currentStage = 'countdown'
      this.user = user

      this.setUserStarted(user.id)
    },

    startGame: function() {
      this.currentStage = 'puzzle'
    },

    puzzleComplete: async function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)
      this.currentStage = 'puzzle'

      if (this.puzzleNumber < 10) this.currentStage = 'pause'
      else {
        this.currentStage = 'gameover'

        const score = await this.scoreUser()
        this.userScoreNumber = score.number
        this.userScore = score.text
        this.userTime = this.times.reduce((a, b) => a + b, 0)
        this.saveUserResult()
      }
    },

    nextPuzzle: function() {
      this.puzzleNumber += 1
      this.currentStage = 'puzzle'
    },

    setUserStarted: function(userId) {
      return db
        .collection('users')
        .doc(userId.toString())
        .update({ started: true })
    },

    saveUserResult: function() {
      return db
        .collection('users')
        .doc(this.user.id.toString())
        .update({
          choices: this.choices,
          times: this.times,
          score: this.userScoreNumber,
          time: this.userTime,
        })
    },

    getSolution: function() {
      return db
        .collection('solution')
        .doc('0')
        .get()
        .then(doc => doc.data())
    },

    scoreUser: async function() {
      const solutionDoc = await this.getSolution()
      const solution = solutionDoc.choices

      let correct = 0
      for (const choice in this.choices) {
        if (solution[choice] === this.choices[choice].toString()) correct += 1
      }

      return { text: `${correct}/${solution.length}`, number: correct }
    },
  },
}
</script>
